import Vue from 'vue'
import VueRouter from 'vue-router'

import { aboutRoutes } from '@/views/about/about.routes';
import { notFoundRoutes } from '@/views/not-found/not-found.routes';
import { translateRoutes } from '@/views/translate/translate.routes';
import { feedbackRoutes } from '@/views/feedback/feedback.routes';
import { translationsRoutes } from '@/views/translations/translation.routes';
import { shareRoutes } from "@/views/share/share.routes";
import { statsRoutes } from "@/views/stats/stats.routes";
import { areyouhealthyRoutes } from "@/views/areyouhealthy/areyouhealthy.routes";

interface InterfaceRoute {
  meta: { title: string };
}

const DEFAULT_ROUTE: InterfaceRoute = {
  meta: { title: '' }
};

Vue.use(VueRouter);

// const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   }
// ]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", redirect: "/translate" },
    aboutRoutes,
    notFoundRoutes,
    translateRoutes,
    feedbackRoutes,
    translationsRoutes,
    shareRoutes,
    statsRoutes,
    areyouhealthyRoutes
  ],
});

router.beforeEach((to, from, next) => {
  const {
    meta: { title }
  } =
    ((to.matched
      .slice()
      .filter(route => route.meta.title)[0] as unknown) as InterfaceRoute) ||
    DEFAULT_ROUTE;

  if (title) {
    document.title = `${document.title.replace(/\s\|.*/, '')} | ${title}`;
  }

  next();
});

export default router
